module.exports = __webpack_public_path__ + "img/drop.68a42325.png";